import React from "react";
import { RowColors, RowOptions } from "../TableSection/TableSection";
import { CardTable } from "../CardTable/CardTable";
import CodeAlongLogo from "../../assets/headings/code-alongs.svg"
import "./CodeAlong.scss"
import { SectionProps } from "../../App";
import { getCourseContent } from "../../data/courseContent";
import { hideRowLinks, isReleased } from "../../data/releaseSchedule";

export class CodeAlong extends React.Component<SectionProps> {


  render() {
    const { codeAlongsTable } = getCourseContent();
    const modifiedRows: RowOptions[] = codeAlongsTable.rows.map((row) => {
      if (!isReleased(row)) {
        return {
          ...hideRowLinks(row),
          backgroundColor: RowColors.LOCKED,
          locked: true,
        };
      }
      return row;
    });

    return (
      <section
        id="codealong"
        className={`anchor codealong ${this.props.static ? "static" : ""}`}
      >
        <div className="section-heading">
          <img
            className="codealong-logo logo"
            src={CodeAlongLogo}
            alt="codealong text"
          />
        </div>
        <CardTable
          header={codeAlongsTable.header}
          rows={modifiedRows}
          resourceStartIndex={4}
          columnTracks="minmax(6.5rem, 1.6fr) minmax(5.25rem, 1.2fr) minmax(8rem, 1.75fr) minmax(3.2rem, 0.75fr) minmax(2.6rem, 0.5fr) minmax(2.9rem, 0.55fr)"
          blurb={`CS15 Code-Alongs are your one stop shop for getting hands-on experience with guided coding exercises in order to better understand the concepts of OOP! We know that lectures can at times feel very abstract, and that we sometimes need examples in code in order to fully understand how these concepts work.
                Throughout the semester, we will host various code-alongs in order to assist you all with the skills necessary for succeeding in the course!`}
        />
      </section>
    );
  }
}
